(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/demo-carousel/assets/javascripts/demo-carousel-onboarding-fullscreen.js') >= 0) return;  svs.modules.push('/components/onboarding/demo-carousel/assets/javascripts/demo-carousel-onboarding-fullscreen.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  ImageProvider,
  SvgImage
} = svs.components.onboarding.imageHelpers;
const {
  Carousel,
  CarouselSlide,
  CarouselImageAspect: {
    SQUARE
  }
} = svs.components.tbUi.carousel;

const CarouselDemoOnboardingFullscreen = _ref => {
  let {
    onCloseFullscreen
  } = _ref;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);

  const productNameForTracking = 'Keno';

  const slides = [{
    actions: [{
      label: 'Action 1',
      url: '/'
    }, {
      label: 'Action 2',
      url: '/'
    }],
    image: React.createElement(SvgImage, {
      alt: "Minst 50 miljoner i potten",
      imagePath: "demo-carousel/demo_image_0.jpg"
    }),
    title: 'Rubrik! Med möjlighet till flera rader.',
    body: 'Välj just din lyckoplats var som helst i Sverige. Markera en valfri plats på kartan, spela på din hemadress eller den plats du befinner dig på just nu.'
  }, {
    actions: [{
      label: 'Burgaz',
      url: '/'
    }],
    image: React.createElement(SvgImage, {
      alt: "Minst 50 miljoner i potten",
      imagePath: "demo-carousel/demo_image_1.jpg"
    }),
    title: 'Rubrik 2! Med möjlighet till flera rader.',
    body: 'Välj just din lyckoplats var som helst i Sverige. Markera en valfri plats på kartan, spela på din hemadress eller den plats du befinner dig på just nu.'
  }, {
    actions: [{
      label: 'Friez',
      url: '/'
    }],
    image: {
      src: "".concat(cdn, "/images/onboarding/demo-carousel/demo_image_2.jpg")
    },
    title: 'Rubrik 3! Med möjlighet till flera rader.',
    body: 'Välj just din lyckoplats var som helst i Sverige. Markera en valfri plats på kartan'
  }];

  const onClosetrackAndCloseFullscreen = e => {
    svs.components.analytics.trackEvent({
      category: 'close_guide',
      action: 'FTU',
      opt_label: productNameForTracking
    });
    onCloseFullscreen(e);
  };
  return React.createElement(ImageProvider, null, React.createElement("div", {
    className: "pg_fullscreen_onboarding pg_fullscreen_onboarding--demo-carousel"
  }, React.createElement("div", {
    className: "pg_fullscreen_onboarding__content"
  }, React.createElement("div", {
    className: "pg_fullscreen_onboarding__content__close ".concat(isLoggedIn ? 'logged-in' : '')
  }, React.createElement(ReactIconButton, {
    onClick: onClosetrackAndCloseFullscreen
  }, React.createElement(ReactIcon, {
    color: "icon",
    icon: "close",
    size: 100
  }))), React.createElement(Carousel, {
    branding: "keno"
  }, slides.map((_ref2, slideIndex) => {
    let {
      actions,
      body,
      image,
      title
    } = _ref2;
    return React.createElement(CarouselSlide
    , {
      actions: actions === null || actions === void 0 ? void 0 : actions.map((action, actionIndex) => _objectSpread(_objectSpread({}, action), {}, {
        tracking: {
          category: "click_slide_".concat(slideIndex + 1, "_cta").concat(actionIndex + 1),
          action: 'FTU',
          opt_label: productNameForTracking
        }
      }))
      ,
      aspect: SQUARE
      ,
      image: image
      ,
      key: "slide_".concat(slideIndex + 1)
      ,
      title: title
    }, React.createElement("p", null, body));
  })))));
};
setGlobal('svs.components.onboarding.demo.CarouselDemoOnboardingFullscreen', CarouselDemoOnboardingFullscreen);

 })(window);